__turbopack_context__.v({
  "flippedImage": "_9pTEaq_flippedImage",
});
